var $ = jQuery = require('jquery');

//var templates = require('../templates');

var Basket = require('./checkout/basket');


    var AddProductToCart = function(obj, options) {
        this.options = options;

        this.data = {

        };

        this.dataResponse = {
        };

        this.selector = {

        };

        this.url = {

        };

        this.hbs = {

        };

        this.cookie = {
            someVar: 'someVar'
        };

        this.someVar = [];

        this.isProductAddedToCart;

        this.init();
    };

    AddProductToCart.prototype.init = function() {
        var
            self = this
            ;

        if ( !$('body').hasClass('someclass') ) {
            //return;
        }

        self.bindUI();

        self._controlButtonAddToCart();
    };

    AddProductToCart.prototype.bindUI = function() {
        var
            self = this
            //, $link = $(a)
            , someVar = 'bar'
            ;

        //$link.on('click', $.proxy(self.onClickQuickOrder, null, self, $link, someVar))
    };

    AddProductToCart.prototype._controlButtonAddToCart = function () {
        var
            self = this
            ,goToCart = $('.go-to-cart')
            ,currentButtonToCart = $('.summary.entry-summary .button.add-to-cart')
            ,cartRemoveButtons =$('.cart-remove')
            ,modalCartMessageWithoutPrice = $('#cart_message_without_price')
            ,isShowedModalCartMessageWithoutPrice = false
            ;
       $('.button.add-to-cart').each(function (i, el) {
	el=$(el);
            el.detach('click');
            el.on('click', $.proxy(self._onAddProductToCart, null, self));
        });

        if (pageType == 'ProductProduct'
            || pageType == 'ProductProductCommon') {
            goToCart.on('click', $.proxy(function(self, e) {
                var
                    isCurrentProductAlreadyOnCart = false
                    ,currentProductId
                    ;

                if (currentButtonToCart.length) {
                    currentProductId = currentButtonToCart.attr('data-product_id')

                    if (!self.isProductAddedToCart) {
                        if (cartRemoveButtons.size() == 0) {
                            currentButtonToCart[0].click();
                        }

                        /*cartRemoveButtons.each(function(el) {
                         if (currentProductId == el.attr('data-product_id')) {
                         isCurrentProductAlreadyOnCart = true;
                         }
                         });

                         if ( !isCurrentProductAlreadyOnCart ) {
                         currentButtonToCart[0].click();
                         }*/
                    }
                } else {
                    if (cartRemoveButtons.size() == 0) {
                        if (modalCartMessageWithoutPrice.length) {
                            if ( !isShowedModalCartMessageWithoutPrice ) {
                                isShowedModalCartMessageWithoutPrice = true;

                                jQuery(modalCartMessageWithoutPrice[0]).modal('show');

                                e.preventDefault();
                            }
                        }
                    }
                }
            }, null, self))
        }
    };

    AddProductToCart.prototype._onAddProductToCart = function (self, ev) {
        ev.preventDefault();
        var node = $(ev.target),
            data = {}
            ,basketEmpty = $('.menu-item .basket-empty')
            ,basketFull = $('.menu-item .basket-full')
            ,basketEmptySidebar = $('.sidebar .basket-empty')
            ,basketFullSidebar = $('.sidebar .basket-full')
            ;
        if (node[0].tagName != 'A') {
            node = node.parents('a');
        }
        if (node.hasAttr('data-together_hash')) {
            data.together_hash = node.attr('data-together_hash');
            var togetherItemContainer = node.parents('.together-item-container');
            self.__animateImageToProductCart(jQuery('#' + togetherItemContainer.find('img').item(0).generateID()), 'fast');
            self.__animateImageToProductCart(jQuery('#' + togetherItemContainer.find('img').item(1).generateID()), 'fast');
        } else {
            data.product_id = node.attr('data-product_id');
            data.quantity = $('input[name=quantity' + data.product_id + ']').length
                ? jQuery('input[name=quantity' + data.product_id + ']').val()
                : 1;
            self.__animateImageToProductCart(jQuery('#image' + data.product_id), 'slow');
        }

        jQuery.ajax('index.php?route=module/cart/callback', {
            type: 'post',
            dataType: 'html',
            data: data,
            success: function (html) {

                mobileCartWidget.getAjaxQuantity();

                self.isProductAddedToCart = true;

                var nodeCartWidget = $('.widget.widget_cart');
                if (nodeCartWidget.length) {
                    nodeCartWidget.html(html);
                }
                if (node.find('i').length) {
                    if (!$(node.parents('*')[0]).find('.go-to-cart').length)
                        node.after('<div><a href="/index.php?route=checkout/cart" class="go-to-cart"><img src="/image/svg/278274.png" title="Оформить заказ" alt="Оформить"></a></div>');

                } else {
                    if (!$(node.parents('*')[0]).find('.go-to-cart').length)
                        node.after('<p class="go-to-cart"><a href="/index.php?route=checkout/cart"><b>Перейти в&nbsp;корзину</b></a></p>');
                }
                //_gaq.push(['_trackEvent', 'basket', 'add']);
                Basket._updateModuleCartHead();
                if (0 && $('#c' + id).length && $('#c' + id).hasAttr('data-force_reload')) {
                    //
                    var cartSelectedAccessoriesCategories = Y.JSON.parse(Y.Cookie.getSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'cartSelectedAccessoriesCategories') ? Y.Cookie.getSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'cartSelectedAccessoriesCategories') : '{}');
                    var cartSelectedAccessoriesProducts = Y.JSON.parse(Y.Cookie.getSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'cartSelectedAccessoriesProducts') ? Y.Cookie.getSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'cartSelectedAccessoriesProducts') : '{}');
                    var accessoriesProductToCategory = Y.JSON.parse(Y.Cookie.getSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'accessoriesProductToCategory') ? Y.Cookie.getSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'accessoriesProductToCategory') : '{}');

                    var product_id = $('#c' + id).parents('.cart-accessories-product-item').attr('product_id');
                    var category_id = $('#c' + id).parents('.cart-accessories-product-item').attr('category_id');

                    if (cartSelectedAccessoriesCategories[product_id] == undefined) {
                        cartSelectedAccessoriesCategories[product_id] = [];
                    }
                    cartSelectedAccessoriesCategories[product_id].push(category_id);

                    if (cartSelectedAccessoriesProducts[product_id] == undefined) {
                        cartSelectedAccessoriesProducts[product_id] = [];
                    }
                    cartSelectedAccessoriesProducts[product_id].push(id);

                    accessoriesProductToCategory[id] = category_id;

                    Y.Cookie.setSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'cartSelectedAccessoriesCategories', Y.JSON.stringify(cartSelectedAccessoriesCategories));
                    Y.Cookie.setSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'cartSelectedAccessoriesProducts', Y.JSON.stringify(cartSelectedAccessoriesProducts));
                    Y.Cookie.setSub(Y.MyApp.Inner.COOKIE_SUB_BASKET, 'accessoriesProductToCategory', Y.JSON.stringify(accessoriesProductToCategory));
                    location.reload();
                }
                if (pageType == 'CheckoutCart') {
                    location.reload();
                }

                if (basketEmpty.length) {
                    basketEmpty.remove();
                    basketFull.show();
                }

                if (basketEmptySidebar.length) {
                    basketEmptySidebar.remove();
                    basketFullSidebar.show();
                }
            }
        });
    };

    AddProductToCart.prototype.__animateImageToProductCart = function (image, speed) {
        var cart = jQuery('.sidebar-right');
        //TODO найти и портировать фиксы, связанные с потерей картинки товара.
        try {
            jQuery('body').append('<img src="' + image.attr('src') + '" id="temp" style="position: absolute;z-index:32000; top: ' + parseInt((image.offset().top)) + 'px; left: ' + parseInt(image.offset().left) + 'px;" />');
        } catch (e) {
            return false;
        }

        var params = {
            top: $('html, body').offset().top + 'px',
            left: (parseInt($('html, body').width()) - 300) + 'px',
            opacity: 0.0,
            width: cart.width(),
            heigth: cart.height()
        };
        jQuery('#temp').animate(params, 2000, false, function () {
            $('#temp').remove();
        });
    };

    AddProductToCart.prototype._restoreCookie = function() {
        this.someVar = $.cookie(this._getCookieVarName(this.cookie.someVar));
        if (typeof(this.someVar) != 'undefined'
            && /^{/.test(this.someVar)) {
            this.someVar = $.parseJSON(this.someVar);
        } else {
            this.someVar = {};
        }
    };

    AddProductToCart.prototype._updateCookie = function() {
        $.cookie(this._getCookieVarName(this.cookie.someVar), $.toJSON(this.someVar), {path: '/'});
    };

    AddProductToCart.prototype._getCookieVarName = function(localVarName) {
        return 'AddProductToCart' + '.' + localVarName
    };

    AddProductToCart.DEFAULTS = {
        selector: 'body'
    };

    var old = $.fn.AddProductToCart;

    $.fn.AddProductToCart = function (option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('oc.AddProductToCart');
            var options = $.extend({}, AddProductToCart.DEFAULTS, $this.data(), typeof option == 'object' && option);
            if (!data) $this.data('oc.AddProductToCart', (data = new AddProductToCart(this, options)));
            if (typeof option == 'string') data[option].call($this)
        })
    };

    $.fn.AddProductToCart.Constructor = AddProductToCart;

    $.fn.AddProductToCart.noConflict = function () {
        $.fn.AddProductToCart = old;
        return this
    };

module.exports = new AddProductToCart();


// WEBPACK FOOTER //
// ./assets/javascript/addproducttocart.js